import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isUserAuthenticated: false,
        authenticatedUserData: {}
    },
    mutations: {
        setUserLoggedOut(state) {
            state.isUserAuthenticated = false
            state.authenticatedUserData = {}

            let fcm_data = localStorage.getItem('fcm_data');
            if (fcm_data) {
                let fcm_data_decoded = JSON.parse(fcm_data);
                if (fcm_data_decoded.fcm_uuid) {
                    axios.post("api/delete_fcm_token", { fcm_uuid: fcm_data_decoded.fcm_uuid })
                }

                localStorage.removeItem('fcm_data');
            }
            sessionStorage.removeItem('authenticatedUserToken');
        },
        setUserLoggedIn(state, userData) {
            state.isUserAuthenticated = true
            state.authenticatedUserData = userData
        }
    }
})

// export default new Vuex.Store({
//     state: {
//         cartProducts: [],
//         loggedUser: {}
//     },
//     getters: {
//         cartProducts: state => {
//         return state.cartProducts
//     },
//     getLoggedUser: state => {
//     return state.loggedUser
// }
// },
// mutations: {
//     ADD_CART_LOCAL: (state, product) => {
//         state.cartProducts.push(product)
//         localStorage.setItem('iki-cart', JSON.stringify(state.cartProducts))
//     },
//     REMOVE_CART_LOCAL: (state, product) => {
//         state.cartProducts = state.cartProducts.filter(p => p.id !== product.id)
//         localStorage.setItem('iki-cart', JSON.stringify(state.cartProducts))
//     },

//     ADD_LOGGED_USER: (state, user) => {
//         state.loggedUser = user
//         // localStorage.setItem('_auth', encryptUser(user))
//     },

//     SET_CART_PRODUCTS: (state, products) => {
//         state.cartProducts = []
//         state.cartProducts = products
//     },
//     UPDATE_CART_LOCAL:(state,product)=>{
//         let cartProduct = state.cartProducts.find((item,index) =>{
//             return item.id === product.id
//         })
//         cartProduct.quantity = product.quantity
//         localStorage.setItem('iki-cart',JSON.stringify(state.cartProducts))



//     },
// }
// // actions: {}
// })